import React, { useMemo } from 'react';
import { useUnreadNotificationCount } from '../hooks/useUnreadNotificationCount';
import { NotificationCountContext } from './notificationCountContext';

export function NotificationCountProvider({
  isCoach,
  children,
}: {
  isCoach: boolean;
  children: React.ReactNode;
}) {
  const { unreadCount, refresh, adjustUnreadCount } = useUnreadNotificationCount(isCoach);
  const value = useMemo(
    () => ({ unreadCount, refreshUnreadCount: refresh, adjustUnreadCount }),
    [unreadCount, refresh, adjustUnreadCount],
  );

  return (
    <NotificationCountContext.Provider value={value}>
      {children}
    </NotificationCountContext.Provider>
  );
}
